import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './app/App';
import '@fontsource-variable/inter';
import 'react-grid-layout/css/styles.css';
import './app/styles/globals.css';
import { safeStorage } from '@/infrastructure/lib/storage';
import { loadPublicConfig } from '@/infrastructure/config/bootstrap-public-config';

console.log("Starting application...");

// Clean up enhanced_token from local storage
try {
  if (safeStorage.getItem('enhanced_token')) {
    console.log("Removing deprecated enhanced_token from storage");
    safeStorage.removeItem('enhanced_token');
  }
} catch (error) {
  console.error("Error cleaning up storage:", error);
}

const container = document.getElementById('root');
if (!container) {
  console.error("Failed to find root element");
  throw new Error("Failed to find root element");
}

// Load env-driven public URLs (docs/terms/privacy) from the backend BEFORE
// mounting React, so the first paint already has the correct URLs in
// window.ENV. Non-blocking on failure — fallback values keep the app usable.
loadPublicConfig().finally(() => {
  try {
    console.log("Creating root...");
    const root = createRoot(container);

    console.log("Rendering app...");
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
    console.log("App rendered successfully");
  } catch (error) {
    console.error("Failed to render app:", error);
    throw error;
  }
});
